export const roundPrice = (p) => Math.floor(p);
